var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

function Header(el) {
  var $el = $(el),
      $menu = $el.find('#menu'),
      $menuButton = $el.find('#menu-button'),
      $searchToggle = $el.find('.js-search-toggle');

  $menuButton.on('click', function(e) {
    e.preventDefault();
    if ($menu.hasClass('active')) {
      $menu.removeClass('active');
      $menu.attr('aria-hidden', 'true');
      $menuButton.attr('aria-expanded', 'false');
      $menuButton.removeClass('is-active');
    } else {
      $menu.addClass('active');
      $menu.attr('aria-hidden', 'false');
      $menuButton.attr('aria-expanded', 'true');
      $menuButton.addClass('is-active');
    }
  });

  $searchToggle.on('click', function(e) {
    e.preventDefault();
    $('.header').toggleClass('search-open');
    $('.search-form.large-screens input[type=text').focus();
  });
}

module.exports = Header;
